// extracted by mini-css-extract-plugin
export default {"card":"StepCard_card__dmTdN","step":"StepCard_step__uoTkh","title":"StepCard_title__HrK0X","description":"StepCard_description__jxgnG"};